export default "__VITE_ASSET__DInbwH0d__"